module.exports = __webpack_public_path__ + "static/Bitrue-68ed0f8c002923a01bfa7550986a1efc.png";